export default "__VITE_ASSET__85aeaa27__"